import { render } from "./ValidationText.vue?vue&type=template&id=824b99ce&scoped=true"
import script from "./ValidationText.vue?vue&type=script&lang=js"
export * from "./ValidationText.vue?vue&type=script&lang=js"

import "./ValidationText.vue?vue&type=style&index=0&id=824b99ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-824b99ce"

export default script